import { render } from "./BlockTitle.vue?vue&type=template&id=a3f5f0d2"
import script from "./BlockTitle.vue?vue&type=script&lang=js"
export * from "./BlockTitle.vue?vue&type=script&lang=js"

import "./BlockTitle.vue?vue&type=style&index=0&id=a3f5f0d2&lang=scss"
script.render = render

export default script